"use client";

import { datadogRum } from "@datadog/browser-rum";
import { ACCOUNT_DATADOG_CONFIG } from "@login/constants/datadog";

import { env } from "../../../utils/libs/env";

if (env.NEXT_PUBLIC_STAGE === "pro") {
  datadogRum.init({
    ...ACCOUNT_DATADOG_CONFIG,
    clientToken: env.NEXT_PUBLIC_ACCOUNT_DATADOG_TOKEN,
    env: env.NEXT_PUBLIC_STAGE,
    version: env.NEXT_PUBLIC_PROJECT_VERSION,
  });
}

console.info({ name: "front-account", version: env.NEXT_PUBLIC_PROJECT_VERSION });

export function DatadogInit() {
  return null;
}
